import { render, staticRenderFns } from "./bankCardCollect.vue?vue&type=template&id=6480d9bc"
import script from "./bankCardCollect.vue?vue&type=script&lang=js"
export * from "./bankCardCollect.vue?vue&type=script&lang=js"
import style0 from "./bankCardCollect.vue?vue&type=style&index=0&id=6480d9bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports